import { useState } from "react";
import { FileSelectorProps } from "./FileSelector";

interface UseFileSelectorController {
  file?: File;
  error?: string;
  selectFile: (file?: File) => void;
}

export const useFileSelectorController = (
  props: FileSelectorProps
): UseFileSelectorController => {
  const [file, setFile] = useState<File | undefined>(undefined);
  const [error, setError] = useState<string | undefined>(undefined);

  const validateFile = (file: File): boolean => {
    // Check file type
    const acceptedTypes = ".csv,.xlsx,.xls".split(",");
    const fileType = file.type;
    const fileExtension = `.${file.name.split(".").pop()}`;

    const isValidType = acceptedTypes.some(
      (type) => type.trim() === fileType || type.trim() === fileExtension
    );

    if (!isValidType) {
      setError(`Invalid file type. Accepted types: ${acceptedTypes}`);
      return false;
    }

    const maxSize = 10 * 1024 * 1024;
    // Check file size
    if (file.size > maxSize) {
      const maxSizeMB = maxSize / (1024 * 1024);
      setError(`File is too large. Maximum size: ${maxSizeMB}MB`);
      return false;
    }

    setError(undefined);
    return true;
  };

  const selectFile = (file?: File) => {
    if (!file) {
      setFile(undefined);
      props.onFileSelected(undefined);
    } else if (validateFile(file)) {
      setFile(file);
      props.onFileSelected(file);
    }
  };

  return {
    file,
    error,
    selectFile,
  };
};
